import {
  AnswerOption,
  CreateAnswerOptionInput,
  CreateAnswerOptionMutation,
  DeleteAnswerOptionMutation
} from "../../API";
import { genericQuery } from "../api/apiUtils";
import * as mutations from "../../graphql/mutations";

export const deleteAnswerOption = async (id: string) => {
  const predicate = { input: { id: id } };
  return await genericQuery<DeleteAnswerOptionMutation, AnswerOption>(
    mutations.deleteAnswerOption,
    "deleteAnswerOption",
    predicate
  );
};

export const createAnswerOption = async (input: CreateAnswerOptionInput) => {
  const predicate = { input: input };
  return await genericQuery<CreateAnswerOptionMutation, AnswerOption>(
    mutations.createAnswerOption,
    "createAnswerOption",
    predicate
  );
};
